import * as React from 'react';

export interface IExpandIcon {
    isExpanded: boolean;
    onExpand: () => void;
}

export const ExpandIcon = (props: IExpandIcon) => {
    return props.isExpanded ? (
        <span
            className={`fa fa-caret-up float-right expand-icon pl-1`}
            onClick={e => {
                e.stopPropagation();
                props.onExpand();
            }}
        />
    ) : (
        <span
            className={`fa fa-caret-down float-right expand-icon pl-1`}
            onClick={e => {
                e.stopPropagation();
                props.onExpand();
            }}
        />
    );
};
